import TextBox from "components/TextBox/TextBox";
import React from "react";
import * as styles from "./AccordionTextItem.module.scss";
import SanityBlockContent from "@sanity/block-content-to-react";
import { ComponentBackgroundColor } from "types/componentBackground";
import classNames from "classnames/bind";
import { Maybe } from "types/graphql-types";
import { Icon } from "@silversea-ssc/ui-components-react";

const cx = classNames.bind(styles);

export type AccordionTextItemType = {
  _key: string;
  title: string;
  content?: Maybe<SanityBlockContent> | Maybe<string>;
};

export interface AccordionTextItemProps {
  item: AccordionTextItemType;
  backgroundColor?: ComponentBackgroundColor;
  isExpanded: boolean;
  setToggleExpanded: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
}

const AccordionTextItem: React.FC<AccordionTextItemProps> = ({
  item,
  isExpanded,
  setToggleExpanded,
  backgroundColor
}) => {
  return (
    <div
      className={cx({
        item: true,
        itemColorWhite: backgroundColor == "white",
        itemColorGray: backgroundColor == "neutral05"
      })}
    >
      <button
        className={styles.header}
        onClick={setToggleExpanded}
        data-content-piece="details_button"
      >
        <h3 className={styles.title}>{item.title}</h3>
        <div>
          <Icon
            name={isExpanded ? "chevron-up" : "chevron-down"}
            size="1.5x"
            padding="inline"
          />
        </div>
      </button>

      {isExpanded && (
        <div className={styles.content}>
          <TextBox content={item.content} fontSize="small" />
        </div>
      )}
    </div>
  );
};

export default AccordionTextItem;
